import { ApolloClient } from '@apollo/client';
import { readConfig } from '@catalogo/core-connect/config';
import { canaryScripts } from '@catalogo/core-canary-scripts';
import { facebookInit } from './modules/facebook';
import { datadogInit } from './modules/datadog';
import { googleRmktInit } from './modules/googlermkt';
import { rtbHouseInit } from './modules/rtbhouse';
import { saikaInit } from './modules/saika';
import { recommendationInit } from './modules/recommendations';
import { gaInit } from './modules/ga/';
import { hotjarInit } from './modules/hotjar';
import { pxInit } from './modules/px';
import { twitterInit } from './modules/twitter';
import { tiktokInit } from './modules/tiktok';
import { criteoInit } from './modules/criteo';
import { socialMinerInit } from './modules/social-miner';
import { webVitalsInit } from './modules/web-vitals';

export const metricsInit = (client: ApolloClient<any>): void => {
  const { config } = readConfig(client);
  facebookInit(config);
  datadogInit(config);
  googleRmktInit(config);
  rtbHouseInit(config);
  recommendationInit();
  saikaInit();
  gaInit(config);
  twitterInit(config);
  criteoInit(config);
  pxInit(config);
  webVitalsInit(config, client);

  canaryScripts('CAT_ONSITE', client, () => socialMinerInit(config));
  canaryScripts('hotjar', client, () => hotjarInit(config));
  canaryScripts('tiktok', client, () => tiktokInit(config));
};
